import React, { Component } from 'react';
import { GeckoCardWrapper, GeckoCardBody } from '../../';

class GeckoCardImage extends Component {
  render() {
    return (
      <GeckoCardWrapper>
        <img
          style={{ width: '100%' }}
          src={this.props.img}
          alt={this.props.alt}
        />

        <GeckoCardBody {...this.props}>{this.props.children}</GeckoCardBody>
      </GeckoCardWrapper>
    );
  }
}

export default GeckoCardImage;
